"use client";

import React from "react";
import { MonitorPlay, Download, Zap } from "lucide-react";
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const features = [{
  title: "Bespoke Itineraries",
  description: "Hand-crafted itineraries shaped around your personal narrative. Through bespoke travel planning, we curate every detail for an effortless travel experience.",
  icon: MonitorPlay
}, {
  title: "Curated Travel Experiences",
  description: "Discover thoughtfully selected LGBTQ+ cruises, Pride celebrations, circuit events, luxury accommodations, and distinctive destinations. We help you explore experiences tailored to your interests, subject to availability and supplier confirmation.",
  icon: Download
}, {
  title: "Personalized Travel Assistance",
  description: "Work one to one with a dedicated agent who learns your preferences and answers your questions as you plan, with quiet, refined attention to detail.",
  icon: Zap
}];
export default function Eliteedgebespokecuration() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="224651" id="eliteedgebespokecuration" className="bg-background text-foreground py-24 px-6 md:px-12 lg:px-24 relative overflow-hidden">
      {}
      <style dangerouslySetInnerHTML={{
      __html: `
        @keyframes scanline {
          0% { top: -10%; opacity: 0; }
          10% { opacity: 1; }
          90% { opacity: 1; }
          100% { top: 110%; opacity: 0; }
        }
        .group:hover .scan-line-anim {
          animation: scanline 2s linear infinite;
        }
      `
    }} />

      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold font-default text-primary tracking-tight mb-4">
            Bespoke Concierge
          </h2>
          <p className="text-muted-foreground text-lg max-w-2xl mx-auto font-default">
            The artistry of custom travel curation. We offer bespoke travel planning and personalized travel experiences, thoughtfully crafted with exceptional attention to detail.
          </p>
        </div>

        <div ref={ref} className={`grid grid-cols-1 md:grid-cols-3 gap-8 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {features.map((feature, i) => {
          const Icon = feature.icon;
          return <Card key={i} data-index={i} className="group relative overflow-hidden bg-gradient-to-b from-secondary/50 to-transparent border-border/50 hover:border-primary/30 transition-colors duration-500 rounded-2xl shadow-md">
                {}
                <div className="absolute inset-0 pointer-events-none overflow-hidden z-10 rounded-2xl">
                  <div className="scan-line-anim absolute left-0 w-full h-[1px] bg-[#d4af37] shadow-[0_0_15px_#d4af37] opacity-0" />
                  {}
                  <div className="absolute inset-0 bg-primary/5 opacity-0 group-hover:opacity-100 transition-opacity duration-700" />
                </div>

                <CardHeader className="relative z-20 pb-4">
                  <div className="mb-6 inline-flex h-14 w-14 items-center justify-center rounded-xl bg-background border border-border/40 shadow-sm">
                    <Icon className="size-7 text-[#d4af37] drop-shadow-[0_0_2px_rgba(212,175,55,0.5)] transition-transform duration-500 group-hover:scale-110" />
                  </div>
                  <CardTitle className="text-xl font-bold text-primary font-default tracking-wide">
                    {feature.title}
                  </CardTitle>
                </CardHeader>
                
                <CardContent className="relative z-20">
                  <CardDescription className="text-muted-foreground text-base leading-relaxed font-default">
                    {feature.description}
                  </CardDescription>
                </CardContent>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}